export class AppConsts {
  public static readonly AppName = 'TrainingTracking'
  public static readonly GrafanaConfigurationName = 'grafana';
}